export default "__VITE_ASSET__D30G8RIv__"